<template>
    <div class="Coupon">
        <Header msg='优惠券' :type="ctype"/>
        <img src="@/assets/comm/my_bg_Coupon@3x.png" class="coupon-null" v-if="shownull">
        <div v-if="!shownull">
          <div v-for="(e, i) in pageData"
                :key="i">
            <div class="Coupon-card"
                :class="e.status == 0 ? '':'cantUse'" 
                :style="{'background-image': 'url('+ (e.status == 0 ? couponUse:couponCantUse) +')'}" 
                @click="handleClick(e, i)">
              <div class="cover-top"></div>
              <div class="cover-bottom"></div>
              <div class="card-left">
                <img src="@/assets/comm/com_Label@3x.png" class="couponCheck" v-show="e.isCheck"/>
                <p class="Coupon-money">￥<span>{{e._sub_price}}</span></p>
              </div>
              <div class="card-content flex flex-j-c-center">
                <p class="ellipsis-more" style="-webkit-line-clamp: 2;">{{e.name}}</p>
                <p>有效期至{{e.end_time}}</p>
              </div>
              <div class="card-right">{{e.status === 0 ? '立即使用' : e.status === 1 ? '已使用':'已失效'}}</div>
            </div>
          </div>
          <!-- <div class="Coupon-card cantUse" :style="{'background-image': 'url('+ couponCantUse +')'}">
            <div class="cover-top"></div>
            <div class="cover-bottom"></div>
            <div class="card-left">
              <img src="@/assets/comm/com_Label@3x.png" class="couponCheck"/>
              <p class="Coupon-money">￥<span>500</span></p>
            </div>
            <div class="card-content flex flex-j-c-center">
              <p class="ellipsis">反馈老用户优惠券</p>
              <p>有效期至2019-12-31</p>
            </div>
            <div class="card-right">不可用</div>
          </div> -->
        </div>
    </div>
</template>

<script>
import Header from '@/components/Header.vue';
import {getCouponList} from '@/api';
import { Toast } from 'mint-ui';

export default {
  name: 'Coupon',
  components: {
    Header
  },
  data() {
    return {
      couponUse: require('@/assets/comm/bg_Coupon_usable@3x.png'),
      couponCantUse: require('@/assets/comm/bg_Coupon_Disable@3x.png'),
      shownull: false,
      pageData: [], // 优惠券数据
      pageType: 'mine', // 页面类型 ==》判断来自什么页面
      ctype: '' // Header type
    }
  },
  created() {
    this.getlist();
    this.pageType = this.$route.query.type;
    if (this.pageType === 'mine') this.ctype = 'Order';
  },
  methods: {
    /**
     * 选择优惠券
     * e 选择的优惠券信息
     * i 选择的优惠券索引
     */
    handleClick(e, i) {
      if (this.pageType === 'pay') {
        this.pageData[i].isCheck = !this.pageData[i].isCheck
        if (this.pageData[i].isCheck) {
          sessionStorage.setItem('_couponPay', JSON.stringify(e));
          this.$router.go(-1);
        } else {
          sessionStorage.removeItem("_couponPay");
        }
      } else {
        Toast({message: '请在订单中使用', className: 'iconfont icon-close', duration: 1500});
      }
    },
    // 获取优惠券列表
    getlist() {
      getCouponList().then(res => {
        let couponData = JSON.parse(sessionStorage.getItem('_couponPay'));
        if (res.data.list.length === 0) {
          this.shownull = true
        } else {
          let ARR = res.data.list.map(element => {
            if (couponData && (element.user_coupon_id === couponData.user_coupon_id)) {
              element.isCheck = true;
            } else {
              element.isCheck = false;
            }
            element._end_time = element.end_time.slice(0, 10).replace(RegExp('.', 'g'), '-')
            element._sub_price = Number(element.sub_price).toFixed(0)
            return element;
          });
          this.pageData = ARR;
        }
      })
    }
  },
};
</script>

<style scoped lang="less">
.Coupon{
    min-height: 100vh;
    padding: 0.54rem 0 0.6rem;
    font-size: 0.16rem;
    .coupon-null{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 2.84rem;
      height: 1.83rem;
    }
    .Coupon-card{
      width: 90%;
      height: 1rem;
      border-radius: 6px;
      margin: 0 auto;
      // background: white;
      position: relative;
      margin-bottom: 0.13rem;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .cover-top, .cover-bottom{
        position: absolute;
        right: 0;
        width: 10px;
        height: 20px;
        // background: white;
        z-index: 9;
      }
      .cover-top{
        top: 0;
        border-radius: 0 6px 0 0;
      }
      .cover-bottom{
        bottom: 0;
        border-radius: 0 0 6px 0;
      }
      .card-left{
        width: 1.15rem;
        height: 1rem;
        left: 0;
        position: absolute;
        top: 0;
        border-radius: 6px 0 0 6px;
        // background: linear-gradient(90deg,#FABF01,#FA9901);
        .Coupon-money{
          position: absolute;
          top: 50%;
          left: 0.01rem;
          color: white;
          font-size: 0.25rem;
          transform: translateY(-50%);
          span{
            font-size: 0.36rem;
          }
        }
        .couponCheck{
          position: absolute;
          top: 0;
          left: 0;
          width: 0.36rem;
          height: 0.36rem;
        }
      }
      .card-content{
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 1.25rem;
        flex-direction: column;
        text-align: left;
        max-width: 1.7rem;
        &>:first-child{
          color: #333333;
          font-size: 0.16rem;
          margin-bottom: 0.18rem;
          font-weight: bold;
        }
        &>:last-child{
          color: #999999;
          font-size: 0.12rem;
        }
      }
      .card-right{
        writing-mode:tb-rl;
        position: absolute;
        top: 0;
        right:0.10rem;
        line-height: 0.3rem;
        color: #FABF01;
        font-size: 0.12rem;
        height: 1rem;
        letter-spacing: 3px;
        font-weight: bold;
        // border-left: 1px solid #E6E6E6;
      }
      // .card-left:after {
      //   content: ' ';
      //   width: 0;
      //   height: 100%;
      //   /* 绝对定位进行偏移 */
      //   position: absolute;
      //   top: 0;
      // }
      // .card-left:after {
      //   /* 圆点型的border */
      //   border-left: 8px dotted white;
      //   /* 偏移一个半径，让圆点的一半覆盖p */
      //   right: -4px;
      // }
    }
    // .Coupon-card:after {
    //   content: ' ';
    //   width: 0;
    //   height: 100%;
    //   /* 绝对定位进行偏移 */
    //   position: absolute;
    //   top: 0;
    // }
    // .Coupon-card:after {
    //   /* 圆点型的border */
    //   border-left: 20px dotted #F6F6FA;
    //   /* 偏移一个半径，让圆点的一半覆盖p */
    //   right: -10px;
    // }
    // 不可用状态
    .cantUse{
      // .card-left{
      //   background: #E6E6E6!important;
      // }
      .card-content, .card-right{
        color: #999999!important;
        p{
          color: #999999!important;
        }
      }
    }

    
}
</style>
